@if (isVisible()) {
<div class="d-flex align-items-center">
	<i class="material-icons me-2">language</i>
	<form class="nav-form me-5">
		<div class="form-group pb-0 mb-0">
			<select class="form-control custom-select" [(ngModel)]="lang" [ngModelOptions]="{'standalone': true}"
				(ngModelChange)="changeLanguage()">
				@for (lang of langList(); track $index) {
				<option [value]="lang">
					{{ labels()["LANGUAGE_" + lang.toUpperCase()] }}
				</option>
				}
			</select>
		</div>
	</form>
</div>
}